export const MediaView = () => {
    return(
        <p>Example</p>
    )
}